var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import { __ } from "@wordpress/i18n";
import { toast } from "react-toastify";
import { getLogsRequest } from "../../../../api/api";
import { WPQTTypes } from "../../../../types/enums";
import { CommentsAndLogsTabContent, TabContentItem, } from "../CommentsAndLogsTabContent";
function LogsTabContent({ userId }) {
    const fetchLogs = () => __awaiter(this, void 0, void 0, function* () {
        try {
            const response = yield getLogsRequest(userId, WPQTTypes.User);
            return response.data;
        }
        catch (error) {
            console.error(error);
            toast.error(__("Failed to load log", "quicktasker"));
        }
    });
    return (_jsx(CommentsAndLogsTabContent, { typeId: userId, fetchData: fetchLogs, renderItem: (log) => _jsx(TabContentItem, { log: log }), noDataMessage: __("No logs available", "quicktasker"), explanation: __("Logs can be seen only by WordPress users (with required permissions)", "quicktasker") }));
}
export { LogsTabContent };
